module.exports = __webpack_public_path__ + "img/arrow.6b0d52fc.svg";